<template>
	<div v-if="show" class="dropdown-root">
		<ul class="dropdown-list">
			<li v-for="item in menuItems" :key="item.id" class="dropdown-item" @click.stop="navigateToPage(item)">
				<i :class="['iconfont', item.icon, 'dropdown-item__icon']"></i>
				<div class="dropdown-item__text">{{ item.text }}</div>
			</li>
		</ul>
	</div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { buildCategoryPath, normalizeCompanyId } from '#shared/categoryRoutes';

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	goodDetail: {
		type: String,
		default: '',
	},
});

const emit = defineEmits(['close']);

/** 与 DcHeader 的 provide 配对：在子站「更多」菜单内跳转前收起顶栏下拉 */
const closeDcHeaderDropdown = inject('closeDcHeaderDropdown', null);

const route = useRoute();

const companyId = computed(() => route.params.companyId || route.query.companyId || '1');

const menuItems = computed(() => {
	const cid = normalizeCompanyId(companyId.value);
	const baseItems = [
		{ id: 1, icon: 'icon-fuwuhaoxiaochengxutubiao_shouye01', text: '首页', path: '/' },
		{ id: 2, icon: 'icon-fuwuhaoxiaochengxutubiao_fenlei01', text: '分类搜索', path: buildCategoryPath(cid) },
		{ id: 3, icon: 'icon-fuwuhaoxiaochengxutubiao_rezhan01', text: '热门站点', path: '/company' },
		{ id: 4, icon: 'icon-fuwuhaoxiaochengxutubiao_gouwuche01', text: '购物车', path: '/buyCar' },
		{ id: 5, icon: 'icon-fuwuhaoxiaochengxutubiao_wode01', text: '我的服务', path: '/my' },
	];

	if (cid !== '1' && !props.goodDetail) {
		baseItems.push(
			{
				id: 6,
				icon: 'icon-gongneng_zhengzhao',
				text: '资质证照',
				path: `/${cid}/certification.html`,
			},
			{
				id: 7,
				icon: 'icon-zizhanshouye_fenxiang',
				text: '分享二维码',
				path: `/${cid}/share`,
			}
		);
	}

	return baseItems;
});

const navigateToPage = item => {
	if (typeof closeDcHeaderDropdown === 'function') {
		closeDcHeaderDropdown();
	}
	emit('close');
	navigateTo(item.path);
};
</script>

<style scoped lang="scss">
.dropdown-root {
	padding: 0;
}

.dropdown-list {
	margin: 0;
	padding: 0.17rem 0 0 1.08rem;
	list-style: none;
	font-size: 1.17rem;
	font-family: NotoSansSC-Regular, NotoSansSC, 'Source Han Sans', sans-serif;
	font-weight: 400;
	color: #ffffff;
	line-height: 1.67rem;
}

.dropdown-item {
	height: 2.67rem;
	display: flex;
	align-items: center;
	cursor: pointer;
}

.dropdown-item__icon {
	font-size: 1rem;
	margin-right: 1rem;
	color: #ffffff;
}

.dropdown-item__text {
	flex: 1;
	height: 100%;
	line-height: 2.67rem;
	border-bottom: 0.08rem solid #666666;
}

.dropdown-item:last-child .dropdown-item__text {
	border-bottom: 0;
}
</style>
